import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hendersonvilleConfig } from "./data";

export default function HendersonvillePage() {
  return <CityPageTemplate config={hendersonvilleConfig} />;
}